import { InvitationMessage, InvitationMessageType } from '@playcastdotio/Messaging';
import { observedInvitationState } from '../../../stores/globalStores';

export const handleInvitationMessage = (message: InvitationMessage) => {
  console.log('[Invitation] Received invitation message:', message);

  switch (message.type) {
    case InvitationMessageType.INVITATION_MACHINE_HASH_QUERY_RESPONSE: {
      console.log('Received INVITATION_MACHINE_HASH_QUERY_RESPONSE from', message.id);
      const invitation = message.invitation;
      if (invitation) {
        console.log('Invitation found:', invitation);
        observedInvitationState.updateState(invitation);
      } else {
        console.log('Invitation not found');
      }
      break;
    }
    default: {
      console.warn('[Invitation] Unknown invitation message type:', message.type);
    }
  }
};
